import { memo } from 'react'

import clsx from 'clsx'

import LogoIconNew from '@/shared/icons/LogoIconNew.svg'
import LogoIconText from '@/shared/icons/LogoIconText.svg'
import LogoIconTextLight from '@/shared/icons/LogoTextIconLight.svg'

import styles from './styles.module.scss'

type LogoProps = {
  withText?: boolean
  isBlack?: boolean
  newLogo?: boolean
}

const Logo = ({
  withText = false,
  isBlack = false,
  newLogo = false,
}: LogoProps) => {
  if (withText)
    return (
      <span className={styles.logo}>
        <img
          src={!isBlack ? LogoIconText : LogoIconTextLight}
          className={clsx(styles.image)}
        />
      </span>
    )

  return (
    <span className={styles.logo}>
      <img src={LogoIconNew} className={clsx(styles.image)} />
    </span>
  )
}

export default memo(Logo)
